(function(){
    'use strict';

    angular.module('elogbooks.common.conversations', []);
})();
